/* eslint-disable import/prefer-default-export */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getStringifiedQueryParams } from 'utils/helpers/fetch';

const oidcStorage = JSON.parse(
  sessionStorage.getItem(
    `oidc.user:${process.env.REACT_APP_AUTH_URL}:${process.env.REACT_APP_IDENTITY_CLIENT_ID}`
  )
);
const auth = `Bearer ${oidcStorage?.access_token}`;

export const loadingManagementApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_PRODUCT_LOADING_BASE_URL}/`,
    keepUnusedDataFor: 0,
    paramsSerializer: getStringifiedQueryParams,
    prepareHeaders: headers => {
      if (oidcStorage) headers.set('authorization', auth);
      return headers;
    },
  }),
  endpoints: () => ({}),
  reducerPath: 'loadingManagementApi',
  tagTypes: [
    'AuthorizationSequencing',
    'Carrier',
    'CarrierAuthorizationList',
    'SelfAuthorizationList',
    'CustomerAuthorization',
    'CustomerAuthorizationList',
    'Product',
    'SupplierAuthorizationList',
    'Terminal',
  ],
});
